import React from 'react';

import {labels, currentResource} from '../../../../../../../util/utils';
import {archiveReportQualifiedTypeId} from '../../../../../../../util/uiconstants';
import Ellipsis from '../../../../../../Common/Ellipsis/Ellipsis';

export const prop = 'arcRepQlfType';
export const id = 'reportTypeColumn';

export const config = (labels) => ({
	id,
	label: labels.reportType,
	propName: prop,
	width: 'minmax(var(--px-150), 1fr)',
	sortBy: prop,
	customCell: (item) => {
		let reportTypeId = item?.arcRepQlfType || archiveReportQualifiedTypeId.notSelected;
		let reportTypeValue = currentResource.archiveReportQualifiedType.find((x) => x.id === reportTypeId)?.label;

		return <Ellipsis lines={2} content={reportTypeValue || ''} />;
	}
});
